import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router-dom';

export default () => {
    const { t } = useTranslation();
    const { pathname } = useLocation();

    const options = [
        {
            label: t('Racking', { count: 2 }),
            selected: ['/products/racking'].includes(pathname),
            to: '/products/racking',
        },
        {
            label: t('Panel', { count: 2 }),
            selected: ['/products/panels'].includes(pathname),
            to: '/products/panels',
        },
        {
            label: t('System', { count: 2 }),
            selected: ['/products/system-presets'].includes(pathname),
            to: '/products/system-presets',
        },
    ];

    return options;
};
